<template>
<div  class="badge text-white" :class="variant"  >
    {{ $t(user_level)}}
</div>
</template>

<script>
import Vue from 'vue'
import $ from 'jquery'
export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        user_level() {
            if (this.row.user_level===1)
                return 'customers_club.l1'
            if (this.row.user_level===2)
                return 'customers_club.l2'
            if (this.row.user_level===3) {
                return 'customers_club.l3'
            }
            else return 'customers_club.null'
        },
        variant() {
            if (this.row.user_level===1)
                return 'level_1'
            if (this.row.user_level===2)
                return 'level_2'
            if (this.row.user_level===3) {
                return 'level_3'
            }
            return 'normal'
        }

    }
})
</script>

<style>
.level_1{
    color: #fff;
    background-color: #28a745;
}
.level_2{
    color: #fff;
    background-color: #07abea;
}
.level_3{
    color: #fff;
    background-color: #17a2b8;
}
.normal{
    color: #fff;
    background-color: #f7a403;
}
</style>